export const Sizes = {
  xs: 8,
  sm: 12,
  md: 16,
  dl: 20,
  lg: 24,
  xl: 32,
  lx: 40,
  xxl: 48,
  xxxl: 52,
};
